import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: manifest.id,
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "Seven-day detected bars and a safe-to-block line for one selected target type: IPs or domains.",
    domain: "ip-blocking",
    visual: "Bar + line chart",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: {
    kind: "chart",
    skeletonMinHeight: "26rem",
    byConfig: (config) => (config.showLatest === false ? { skeletonMinHeight: "22rem" } : {}),
  },
  settings,
  defaultLayoutClassName: "col-span-12",
};
